import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    q: 'How do I receive Mountain Bike Coach Ready?',
    a: [
      'You receive digital access after purchase. The complete system and bonuses are delivered in finished PDF format.',
    ],
  },
  {
    q: 'Is this for beginner MTB coaches?',
    a: [
      'Yes.',
      'The structured system can help newer coaches organize their sessions, while experienced coaches can use the assessments, drills, correction systems and progression tools to expand and structure what they already teach.',
    ],
  },
  {
    q: 'What rider levels does it cover?',
    a: ['Foundation · Developing · Confident · Advanced'],
  },
  {
    q: 'Is this only for beginner riders?',
    a: [
      'No.',
      'The system progresses from foundations through technical control, braking, cornering, climbing, descending, technical terrain, flow, trail reading and advanced rider decisions.',
    ],
  },
  {
    q: 'Do I need to teach the 150 sessions in order?',
    a: [
      'No.',
      'The session library is designed so you can choose material according to the rider’s current level and limiter.',
    ],
  },
  {
    q: 'Can I use it for private riders?',
    a: ['Yes.'],
  },
  {
    q: 'Can I use it for groups and clinics?',
    a: [
      'Yes.',
      'The package includes material for individual riders, group sessions and clinic formats.',
    ],
  },
  {
    q: 'Is the product editable?',
    a: ['No.', 'The materials are delivered as finished professional PDFs.'],
  },
  {
    q: 'Does Mountain Bike Coach Ready include videos?',
    a: [
      'No.',
      'The system is built around professional PDF coaching resources, visual diagrams, drills, structured sessions, assessments and coaching tools.',
    ],
  },
  {
    q: 'Can I print the material?',
    a: ['Relevant assessment and reference pages can be printed where useful.'],
  },
  {
    q: 'What if the system isn’t right for me?',
    a: ['You are protected by the 7-day money-back guarantee.'],
  },
]
